import React from "react";
import Header from "../../../components/ui/Header";
import Footer from "../../../components/ui/Footer";
import WhatsAppButton from "../../../components/ui/WhatsAppButton";

const FaceLecture = () => {
    return (
        <div className="text-gray-900 min-h-screen flex flex-col">
            <Header />

            <main className="flex-1 w-full pt-20 pb-16 px-5 md:px-16 flex flex-col md:flex-row items-center justify-between gap-10">

                {/* IMAGEN – arriba en móvil */}
                <div className="md:w-1/2 flex justify-center order-1 md:order-2">
                    <img
                        src="/assets/images/lectura-de-rostro.jpg"
                        alt="Lectura de rostro para negocios"
                        className="rounded-2xl shadow-lg w-full max-w-sm md:max-w-full"
                    />
                </div>

                {/* TEXTO */}
                <div className="md:w-1/2 space-y-5 order-2 md:order-1">

                    <h1 className="text-3xl sm:text-4xl md:text-6xl font-headline font-bold text-indigo-900 leading-tight">
                        LECTURA DE ROSTRO PARA NEGOCIOS Y EMPRENDIMIENTO
                        <span className="block text-base font-normal text-indigo-700 mt-2">
                            (Selección de personal y seguridad)
                        </span>
                        <span className="block w-20 h-1 bg-purple-400 rounded-full mt-3"></span>
                    </h1>

                    <p className="text-base md:text-lg leading-relaxed text-justify text-gray-700">
                        La morfopsicología, en combinación con el arte chino conocido como{" "}
                        <strong>Mian Xiang</strong>, integra dos técnicas de lectura facial que
                        se complementan para ofrecer herramientas capaces de transformar la forma
                        en que comprendemos a las personas con las que interactuamos en el ámbito
                        profesional y empresarial.
                    </p>

                    <p className="text-base md:text-lg leading-relaxed text-justify text-gray-700">
                        Leer el rostro permite identificar el temperamento, el potencial intelectual,
                        la capacidad de negociación y venta, los niveles de prudencia o imprudencia,
                        las emociones predominantes, los valores personales y la forma de reaccionar
                        ante el conflicto.
                    </p>

                    <p className="text-base md:text-lg leading-relaxed text-justify text-gray-700">
                        Asimismo, esta técnica facilita detectar fortalezas y puntos emocionales a
                        trabajar en colaboradores, socios y equipos, contribuyendo a una selección
                        de personal más consciente y estratégica.
                    </p>

                    <p className="text-base md:text-lg font-semibold text-indigo-900 text-justify">
                        ¡Contáctanos hoy y descubre cómo la lectura de rostro puede transformar tu negocio!
                    </p>
                </div>

                <WhatsAppButton />
            </main>

            <Footer />
        </div>
    );
};

export default FaceLecture;